<a
  [routerLink]="customer.id"
  class="block hover:bg-surface-hover focus:outline-none focus:bg-surface-hover transition duration-150 ease-in-out"
>
  <div class="px-4 py-4 flex items-center gap-2 sm:px-6">
    <div class="text-fg-secondary">
      @if (customer.data.type === 'company') {
        <app-ng-icon class="text-lg" name="heroBuildingOfficeSolid"></app-ng-icon>
      } @else {
        <app-ng-icon class="text-lg" name="heroUserSolid"></app-ng-icon>
      }
    </div>
    <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <div class="text-sm leading-5 font-medium text-fg-primary truncate">
          {{ customer.data.displayName }}
          <span class="ml-1 font-normal text-fg-secondary">
            {{ customer.data.address.city }}
          </span>
        </div>
      </div>
    </div>
    <div class="ml-5 flex-shrink-0">
      <app-ng-icon
        class="text-fg-faint text-sm"
        strokeWidth="3"
        name="heroChevronRight"
      ></app-ng-icon>
    </div>
  </div>
</a>
